module.exports = __webpack_public_path__ + "img/base_activites_trotinette.47e0e6ed.svg";